export type ChangeEventPayload = {
  value: string;
};

export type ExpoTaskbarBlurViewProps = {
  name: string;
};
